import { formatDollars } from "@rewards-web/shared/lib/format-dollars";

export function formatPointsAsDollars(points: number, pointsRate: number) {
  const value = Math.round((points / pointsRate + Number.EPSILON) * 100) / 100;
  return formatDollars(value);
}
